export default __webpack_public_path__ + "6b15d932057930cdecefdcb1804f9851.png";